import React, { Fragment, useEffect } from 'react'
import Sidebar from '../../layout/Sidebar'
import { connect } from 'react-redux';
import { logout } from '../../../actions/auth';
import Spinner from '../../layout/Spinner';
import img from '../../../utils/images';
import { Link } from 'react-router-dom';
import { getCategoryWiseServices } from '../../../actions/category_wise_service';


import PropTypes from 'prop-types';
import Header from '../Header';
const ServicesView = ({ getCategoryWiseServices, categorywise_service: { category_wise_services, loading } }) => {


    //Decleration -> getCategoryWiseServices API data
    // const [rows, setRows] = useState([]);
    useEffect(() => {
        getCategoryWiseServices();
    }, [getCategoryWiseServices])


    return (
        <Fragment>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage'>
                    <Header heading="Services" />
                    <div className='createForm'>
                        <div className="accordion" id="accordionServicesPanels">
                            {loading ? <Spinner /> :
                                category_wise_services.map((categorywise) => (
                                    <div className="accordion-item mb-4" key={categorywise.id}>
                                        <h2 className="accordion-header d-flex justify-content-between align-items-center pe-2" id={`panelsStayOpen-${categorywise.id}`}>
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#panelsStayOpenService-${categorywise.id}`} aria-expanded="false" aria-controls="panelsStayOpen-collapseOne">
                                                {categorywise.categoryName}
                                            </button>
                                            <Link to={`/category/${categorywise.id}`} className='link-primary fs-6 text-decoration-none'><img src={img.edit_icon} width="20px" alt="edit" /></Link>
                                        </h2>
                                        <div id={`panelsStayOpenService-${categorywise.id}`} className="accordion-collapse collapse" aria-labelledby={`panelsStayOpen-${categorywise.id}`} key={`panelsStayOpenService-${categorywise.id}`}>
                                            <div className="accordion-body p-0" key={`categoryServices-${categorywise.id}`}>
                                                {categorywise.services ?
                                                    categorywise.services.map((service) => (
                                                        <div className='catRow'>
                                                            <div className='d-flex justify-content-between p-3 servicesList' key={service.sid}>
                                                                <div>{service.serviceName}</div>
                                                                <div>{service.hrs ? `${service.hrs} hr` : ''} {service.min ? `${service.min} min` : ''}</div>
                                                                <div> {service.price !== null ? `$ ${service.price}` : ''}</div>
                                                            </div>
                                                           
                                                        </div>
                                                    )) : <div><h6 className='fw-bold text-center'>No Services created</h6></div>}
                                            </div>
                                        </div>
                                    </div>

                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
ServicesView.propTypes = {
    logout: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
    categorywise_service: PropTypes.object.isRequired,
    getCategoryWiseServices: PropTypes.func.isRequired,
}
const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    categorywise_service: state.category_wise_service
});

export default connect(mapStateToProps, { getCategoryWiseServices, logout })(ServicesView);
